export const clipboardConfig = {
  copyMessages: {
    successCopied: "Copied to clipboard",
    noSupportClipboard: "Your browser doesn't support clipboard"
  },
  cliboardDelayToHideNotify: 3000
};
